// Returns an icon path based on file extension
export const getFileIcon = (fileName) => {
  if (!fileName || typeof fileName !== "string") return "/icons/doc.png";
  const extension = fileName.split(".").pop().toLowerCase();
  switch (extension) {
    case "pdf":
      return "/icons/pdf.png";
    case "doc":
    case "docx":
      return "/icons/docx.png";
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
      return "/icons/jpg.png";
    case "msg":
      return "/icons/msg.png";
    default:
      return "/icons/doc.png";
  }
};

export default getFileIcon;
